/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_MOBILE_NAV': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 14',
    data: '<path pid="0" d="M19.81.22C17.39 0 0 .3 0 .3l.05 1.48c5.56.22 19.76-.17 19.76-.17a1.44 1.44 0 0 0 0-1.39zM.05 7.78c5.56.22 19.76-.17 19.76-.17a1.44 1.44 0 0 0 0-1.39C17.39 6 0 6.3 0 6.3zM0 12.3l.05 1.48c5.56.23 19.76-.17 19.76-.17a1.44 1.44 0 0 0 0-1.39C17.39 12 0 12.3 0 12.3" _fill="#545454" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_MOBILE_NAV.js